/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.analytics.rpc.LeadGenerationRpc
 */
import * as References from './LeadGenerationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.analytics.rpc.LeadGenerationRpc#createLeadContact
 */
export const CREATE_LEAD_CONTACT_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_analytics_rpc_LeadGenerationRpc_createLeadContact';
export const CREATE_LEAD_CONTACT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_LEAD_CONTACT_MUTATION_FIELD_NAME,
  args: ['listingId', 'action'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createLeadContactRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});